// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2kYGN","balanceDisclaimer":"posDashboard_balanceDisclaimer__3sTUH"};